import moment from 'moment';
import {
  GET_QUIZ_REVIEWS_REQUEST,
  GET_QUIZ_REVIEWS_SUCCESS,
  GET_QUIZ_REVIEWS_FAILURE,
  GET_ONE_QUIZ_REVIEWS_REQUEST,
  GET_ONE_QUIZ_REVIEWS_SUCCESS,
  GET_ONE_QUIZ_REVIEWS_FAILURE,
  UPDATE_QUIZ_REVIEW_REQUEST,
  UPDATE_QUIZ_REVIEW_SUCCESS,
  UPDATE_QUIZ_REVIEW_FAILURE,
  SET_VALUES_REVIEWS,
  CREATE_QUIZ_REVIEW_REQUEST,
  CREATE_QUIZ_REVIEW_SUCCESS,
  CREATE_QUIZ_REVIEW_FAILURE,
  UPDATE_ONE_QUIZ_REVIEW_REQUEST,
  UPDATE_ONE_QUIZ_REVIEW_SUCCESS,
  UPDATE_ONE_QUIZ_REVIEW_FAILURE,
  DELETE_QUIZ_REVIEW_REQUEST,
  DELETE_QUIZ_REVIEW_SUCCESS,
  DELETE_QUIZ_REVIEW_FAILURE,
  SET_DATE_QUIZ_REVIEW,
  IMPORT_SCORES_REQUEST,
  IMPORT_SCORES_SUCCESS,
  IMPORT_SCORES_FAILURE,
  CLOSE_IMPORT_WINDOW,
  DOWNLOAD_PDF_SCORES_REQUEST,
  DOWNLOAD_PDF_SCORES_SUCCESS,
  DOWNLOAD_PDF_SCORES_FAILURE,
  AI_PROCESS_SCORES_REQUEST,
  AI_PROCESS_SCORES_SUCCESS,
  AI_PROCESS_SCORES_FAILURE,
  AI_PROCESS_SCORES_RESET,
  AI_AUTO_PROCESS_SCORES_REQUEST,
  AI_AUTO_PROCESS_SCORES_SUCCESS,
  AI_AUTO_PROCESS_SCORES_FAILURE,
  AI_AUTO_PROCESS_SCORES_RESET,
  PROCESS_BUBBLE_SHEET_REQUEST,
  PROCESS_BUBBLE_SHEET_SUCCESS,
  PROCESS_BUBBLE_SHEET_FAILURE,
  PROCESS_BUBBLE_SHEET_RESET,
  PROCESS_BUBBLE_SHEET_CLEAR_ERRORS,
} from '../actions/score';

const initialState = {
  ongoingRequest: {
    getQuizReviews: false,
    createQuizReview: false,
    deleteQuizReview: false,
    downloadPdfScores: false,
    aiProcessScores: false,
    aiAutoProcessScores: false,
    processBubbleSheet: false,
  },
  quizReviews: {
    selectArray: [],
    data: [],
    amount: 0,
  },
  quizReview: {},
  updateOneQuizReview: {
    state: false,
    student: null,
  },
  importMessage: [],
  loaderDocuments: false,
  aiProcessScoresSuccess: false,
  aiAutoProcessScoresSuccess: false,
  processBubbleSheetSuccess: false,
  processBubbleSheetErrors: [],
};

const setData = (data) => {
  const arrayList = data.map((d) => {
    return { title: d.name, key: d.id, id: d.id };
  });
  return [{ key: 0, title: 'Seleccione', id: 0 }, ...arrayList];
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_QUIZ_REVIEWS_REQUEST:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, getQuizReviews: true },
      };
    case GET_QUIZ_REVIEWS_SUCCESS:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, getQuizReviews: false },
        quizReviews: {
          selectArray: setData(action.result.data),
          data: action.result.data,
          amount: action.result.metadata.amount,
        },
      };

    case GET_QUIZ_REVIEWS_FAILURE:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, getQuizReviews: false },
      };

    case GET_ONE_QUIZ_REVIEWS_REQUEST:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, getOneQuizReviews: true },
      };
    case GET_ONE_QUIZ_REVIEWS_SUCCESS:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, getOneQuizReviews: false },
        quizReview: action.result,
      };
    case GET_ONE_QUIZ_REVIEWS_FAILURE:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, getOneQuizReviews: false },
      };
    case UPDATE_QUIZ_REVIEW_REQUEST:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, updateQuizReview: true },
      };
    case UPDATE_QUIZ_REVIEW_SUCCESS:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, updateQuizReview: false },
      };
    case UPDATE_QUIZ_REVIEW_FAILURE:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, updateQuizReview: false },
      };
    case UPDATE_ONE_QUIZ_REVIEW_REQUEST:
      return {
        ...state,
        updateOneQuizReview: {
          state: true,
          student: action.data.review.student_id,
        },
        time: moment().format('HH:mm'),
      };
    case UPDATE_ONE_QUIZ_REVIEW_SUCCESS:
      return {
        ...state,
        updateOneQuizReview: {
          state: false,
          student: null,
        },
      };
    case UPDATE_ONE_QUIZ_REVIEW_FAILURE:
      return {
        ...state,
        updateOneQuizReview: {
          state: false,
          student: null,
        },
      };
    case SET_VALUES_REVIEWS:
      return {
        ...state,
        quizReview: {
          ...state.quizReview,
          student_reviews_attributes: action.data,
        },
      };
    case CREATE_QUIZ_REVIEW_REQUEST:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, createQuizReview: true },
      };
    case CREATE_QUIZ_REVIEW_SUCCESS:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, createQuizReview: false },
      };
    case CREATE_QUIZ_REVIEW_FAILURE:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, createQuizReview: false },
      };
    case DELETE_QUIZ_REVIEW_REQUEST:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, deleteQuizReview: true },
      };
    case DELETE_QUIZ_REVIEW_SUCCESS:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, deleteQuizReview: false },
      };
    case DELETE_QUIZ_REVIEW_FAILURE:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, deleteQuizReview: false },
      };
    case SET_DATE_QUIZ_REVIEW:
      return {
        ...state,
        quizReview: {
          ...state.quizReview,
          quiz_date: action.date,
        },
      };
    case IMPORT_SCORES_REQUEST:
      return {
        ...state,
        loaderDocuments: true,
      };
    case IMPORT_SCORES_SUCCESS: {
      return {
        ...state,
        importMessage: action.result.message,
        loaderDocuments: false,
      };
    }
    case IMPORT_SCORES_FAILURE:
      return {
        ...state,
        importFailure: true,
        loaderDocuments: false,
      };
    case CLOSE_IMPORT_WINDOW:
      return {
        ...state,
        importMessage: [],
      };
    case DOWNLOAD_PDF_SCORES_REQUEST:
      return {
        ...state,
        ongoingRequest: {
          ...state.ongoingRequest,
          downloadPdfScores: true,
        },
      };
    case DOWNLOAD_PDF_SCORES_SUCCESS:
      return {
        ...state,
        ongoingRequest: {
          ...state.ongoingRequest,
          downloadPdfScores: false,
        },
      };
    case DOWNLOAD_PDF_SCORES_FAILURE:
      return {
        ...state,
        ongoingRequest: {
          ...state.ongoingRequest,
          downloadPdfScores: false,
        },
      };
    case AI_PROCESS_SCORES_REQUEST:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, aiProcessScores: true },
        loaderDocuments: true,
        aiProcessScoresSuccess: false,
      };
    case AI_PROCESS_SCORES_SUCCESS:
      return {
        ...state,
        loaderDocuments: false,
        ongoingRequest: { ...state.ongoingRequest, aiProcessScores: false },
        aiProcessScoresSuccess: true,
      };
    case AI_PROCESS_SCORES_FAILURE:
      return {
        ...state,
        importFailure: true,
        loaderDocuments: false,
        ongoingRequest: { ...state.ongoingRequest, aiProcessScores: false },
        aiProcessScoresSuccess: false,
      };
    case AI_PROCESS_SCORES_RESET:
      return {
        ...state,
        aiProcessScoresSuccess: false,
      };
    case AI_AUTO_PROCESS_SCORES_REQUEST:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, aiAutoProcessScores: true },
        loaderDocuments: true,
        aiAutoProcessScoresSuccess: false,
      };
    case AI_AUTO_PROCESS_SCORES_SUCCESS:
      return {
        ...state,
        loaderDocuments: false,
        ongoingRequest: { ...state.ongoingRequest, aiAutoProcessScores: false },
        aiAutoProcessScoresSuccess: true,
      };
    case AI_AUTO_PROCESS_SCORES_FAILURE:
      return {
        ...state,
        importFailure: true,
        loaderDocuments: false,
        ongoingRequest: { ...state.ongoingRequest, aiAutoProcessScores: false },
        aiAutoProcessScoresSuccess: false,
      };
    case AI_AUTO_PROCESS_SCORES_RESET:
      return {
        ...state,
        aiAutoProcessScoresSuccess: false,
      };
    case PROCESS_BUBBLE_SHEET_REQUEST:
      return {
        ...state,
        ongoingRequest: { ...state.ongoingRequest, processBubbleSheet: true },
        loaderDocuments: true,
        processBubbleSheetSuccess: false,
        processBubbleSheetErrors: [],
      };
    case PROCESS_BUBBLE_SHEET_SUCCESS:
      return {
        ...state,
        loaderDocuments: false,
        ongoingRequest: { ...state.ongoingRequest, processBubbleSheet: false },
        processBubbleSheetSuccess: true,
        processBubbleSheetErrors: action.result.errors || [],
      };
    case PROCESS_BUBBLE_SHEET_FAILURE:
      return {
        ...state,
        importFailure: true,
        loaderDocuments: false,
        ongoingRequest: { ...state.ongoingRequest, processBubbleSheet: false },
        processBubbleSheetSuccess: false,
      };
    case PROCESS_BUBBLE_SHEET_RESET:
      return {
        ...state,
        processBubbleSheetSuccess: false,
      };
    case PROCESS_BUBBLE_SHEET_CLEAR_ERRORS:
      return {
        ...state,
        processBubbleSheetErrors: [],
      };
    default:
      return state;
  }
};

export default reducer;
